import { css } from "@emotion/css";
import { autocompleteClasses } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  UI_ACCENT_BLUE,
  UI_ACCENT_BLUE_HOVER,
  UI_ACCENT_BLUE_OPTION_FOCUS,
} from "../../../constants/ui-colors";

export const styles = {
  scrollbar: css`
    &::-webkit-scrollbar {
      width: 0.5rem;
      background-color: white;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 7.5px;
      background-color: ${grey[300]};
    }
  `,
};

const listItemBase = {
  paddingLeft: "0.5rem !important",
  paddingRight: "0.5rem !important",
  paddingBottom: "0.5rem !important",
  fontSize: "0.9rem",
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
};

export const sxStyles = {
  buttonsWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "0.5rem 0.75rem",
    gap: "0.25rem",
    borderTop: `1px solid ${grey[300]}`,
  },
  listbox: {
    maxHeight: 170,
    padding: 10,
  },
  // Pre-composed sxes for enabled and disabled option rows. Kept as stable
  // module-level references so renderOption can pick one without allocating a
  // new sx object per option per paint.
  listItem: listItemBase,
  listItemDisabled: {
    ...listItemBase,
    color: grey[500],
    backgroundColor: grey[100],
    cursor: "default",
    pointerEvents: "none",
    "&:hover": {
      backgroundColor: `${grey[100]} !important`,
    },
    "&.Mui-focused": {
      backgroundColor: `${grey[100]} !important`,
    },
    // MUI's Autocomplete forces opacity: 0.38 on disabled options via
    // [aria-disabled="true"] and its base styles may load after our sx, so
    // !important is needed to keep the grey text at full opacity.
    '&[aria-disabled="true"]': {
      opacity: "1 !important",
    },
    opacity: "1 !important",
  },
  optionLabel: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  optionCheckIcon: {
    color: UI_ACCENT_BLUE,
    fontSize: "1.1rem",
    flexShrink: 0,
  },
  optionCheckIconDisabled: {
    color: grey[500],
    fontSize: "1.1rem",
    flexShrink: 0,
  },
  autocompleteRoot: {
    [`&.${autocompleteClasses.root}`]: {
      height: "auto",
      minHeight: "2.2rem",
      margin: "0.5rem 0",
    },
    [`& .${autocompleteClasses.inputRoot}`]: {
      gap: "0.25rem",
      padding: "0.4rem 0.75rem",
      flexWrap: "nowrap",
      alignItems: "center",
    },
  },
  popperSpacing: {
    marginTop: "1rem !important",
  },
  autocompleteListbox: {
    "& .MuiAutocomplete-option": {
      "&:hover": {
        backgroundColor: `${UI_ACCENT_BLUE_HOVER} !important`,
      },
      "&.Mui-focused": {
        backgroundColor: `${UI_ACCENT_BLUE_OPTION_FOCUS} !important`,
      },
      '&[aria-selected="true"]': {
        backgroundColor: `${UI_ACCENT_BLUE_OPTION_FOCUS} !important`,
      },
    },
  },
  milestoneOutlinedInput: {
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: `${UI_ACCENT_BLUE} !important`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${UI_ACCENT_BLUE} !important`,
    },
  },
  milestoneInputLabelFocused: {
    "&.Mui-focused": {
      color: `${UI_ACCENT_BLUE} !important`,
    },
  },
  cancelButton: {
    textTransform: "none",
    fontWeight: 500,
    color: grey[500],
    "&:hover": {
      backgroundColor: "transparent",
      color: grey[900],
    },
  },
  addButton: {
    textTransform: "none",
    fontWeight: 600,
    color: UI_ACCENT_BLUE,
    "&:hover": {
      backgroundColor: UI_ACCENT_BLUE_HOVER,
    },
    "&.Mui-disabled": {
      color: grey[400],
    },
  },
  inputLabel: {
    fontSize: "0.75rem",
    top: "3px",
  },
  outlinedInput: {
    fontSize: "0.9rem",
    width: "100%",
  },
  outlinedInputProp: {
    textAlign: "left",
    paddingLeft: "0.5rem",
    fontSize: "0.9rem",
  },
  tagText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    marginRight: "0.25rem",
    display: "inline-block",
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "100%",
  }
};
